const getters = {
  sidebar: state => state.app.sidebar,
  visitedViews: state => state.app.visitedViews,
  selectState:state => state.app.selectState,
  searchWord:state => state.app.searchWord,
  fromPath:state => state.app.fromPath,
  investmentParam:state => state.app.investmentParam,
  companyParam:state => state.app.companyParam,
  sidebarBigWidth:state => state.app.sidebarBigWidth,
  sidebarSmallWidth:state => state.app.sidebarSmallWidth,
  sidebarCriticalValue:state => state.app.sidebarCriticalValue,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  uid: state => state.user.uid,
  email: state => state.user.email,
  introduction: state => state.user.introduction,
  concernArea: state => state.user.concernArea,
  concernIndustry: state => state.user.concernIndustry,
  concernCompany: state => state.user.concernCompany,
  auth_type: state => state.user.auth_type,
  status: state => state.user.status,
  roles: state => state.user.roles,
  setting: state => state.user.setting,
  firstFlag: state => state.user.firstFlag,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  siderbar_routers:state => state.permission.siderbar_routers,
  url:state => state.user.url,
  nextPage:state => state.user.nextPage,
  isSendNews:state => state.user.isSendNews,
  isBindWechat:state => state.user.isBindWechat,
  concernCompanyNum:state => state.user.concernCompanyNum,
  systemName:state => state.user.systemName,
  publicKey:state => state.app.publicKey,
  effectiveTime:state => state.app.effectiveTime,
  publicKeyStoreTime:state => state.app.publicKeyStoreTime,
  unitCode: state => state.app.unitCode
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js